module.exports = __webpack_public_path__ + "img/logo-ppp.83583fd1.png";